module.exports = __webpack_public_path__ + "img/btn_bottom.dc85a6a3.png";